import { render, staticRenderFns } from "./MoleculePaginationWithPerPage.vue?vue&type=template&id=71640e69&scoped=true&"
import script from "./MoleculePaginationWithPerPage.vue?vue&type=script&lang=js&"
export * from "./MoleculePaginationWithPerPage.vue?vue&type=script&lang=js&"
import style0 from "./MoleculePaginationWithPerPage.vue?vue&type=style&index=0&id=71640e69&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71640e69",
  null
  
)

export default component.exports